var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"99%"}},[_c('Tabs',{attrs:{"type":"card","animated":false}},[_c('TabPane',{attrs:{"label":"基础信息"}},[_c('AchAssessComponentTab1')],1),_vm._v(" "),_c('TabPane',{attrs:{"label":"十五宫格"}},[_c('AchAssessComponentCell')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34e8dd00","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/process/performanceManagement/AchAssess.vue
// module id = null
// module chunks = 